import MoneyTextField from '../../../../components/FormInputs/MoneyTextField';
import When from '../../../../components/When';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { MinimumOrderSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const MinimumOrderSectionGeneralSettings = ({
  generalSettings,
  handleBlur,
  handleChange,
  orderSeparation,
}: MinimumOrderSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();
  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_MINIMUM_ORDER_TITLE)}
      description={LangEnum.GENERAL_SETTINGS_MINIMUM_ORDER_DESCRIPTION}
    >
      <>
        <When value={orderSeparation} is={false}>
          <MoneyTextField
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
              handleChange({
                value: event.target.value,
                name: 'minimumOrderValue',
              })
            }
            onBlur={() => handleBlur()}
            size="medium"
            label={translate(LangEnum.GLOBAL_TOTAL)}
            name="minimumOrderValue"
            value={generalSettings.minimumOrderValue}
          />
        </When>
        <When value={orderSeparation} is>
          <MoneyTextField
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
              handleChange({
                value: event.target.value,
                name: 'minimumPreOrderValue',
              })
            }
            onBlur={() => handleBlur()}
            size="medium"
            label={translate(LangEnum.GLOBAL_PRE_ORDER)}
            name="minimumPreOrderValue"
            value={generalSettings.minimumPreOrderValue}
          />
          <MoneyTextField
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
              handleChange({
                value: event.target.value,
                name: 'minimumReadyForDeliveryValue',
              })
            }
            onBlur={() => handleBlur()}
            size="medium"
            label={translate(LangEnum.GLOBAL_READY_FOR_DELIVERY)}
            name="minimumReadyForDeliveryValue"
            value={generalSettings.minimumReadyForDeliveryValue}
          />
        </When>
      </>
    </SettingContainer>
  );
};

export default MinimumOrderSectionGeneralSettings;
